import { render, staticRenderFns } from "./SyncCouchDB.vue?vue&type=template&id=9e88430a&"
import script from "./SyncCouchDB.vue?vue&type=script&lang=js&"
export * from "./SyncCouchDB.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports